<template>
    <div class="activityBanner">
        <swiper class="container" :options="swiperOption" ref="mySwiper">
            <swiper-slide class="item" style="cursor:pointer;" v-for="(item, index) in activityData" :key="index">
                <div style="overflow:hidden;">
                    <!-- <img v-if="item.expand.actFolder == 'luckyWheelSimple'" 
                        src="../../assets/image/price-bg2.gif" />
                    <img v-if="item.expand.actFolder == 'vi-redPacketRain'" 
                        src="../../assets/image/price-bg.gif" /> -->
                    <img :src="$common.getImgUrl(item.webPicture)" alt="">
                </div>
            </swiper-slide>
        </swiper>
        <div class="close-btn" @click="$emit('update:isActivity',false)"></div>
    </div>
</template>
<script>

export default {
    'name': 'mainswiper',
    props:{
        activityData:{
            type: Array,
            default: [],
        }
    },
    data() {
        return {
            swiperOption: {//swiper3    
                speed: 1000,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                autoplay: {
                    delay: 4000, //等4秒下一个
                    disableOnInteraction: false // 用户操作后继续自动轮播
                },
                paginationClickable: true, // 分页点击事件
                autoplayDisableOnInteraction: false, //用户操作后继续自动轮播
                on: {
                    tap: (res)=> {
                       this.onActivity(this.activityData[res.realIndex]);
                    },
                },
            },
        };
    },
    mounted() {
    },
    methods: {
        // 转盘活动
        onActivity(item) {
            if (!this.$common.getUser()) {
                this.$message.warning(this.$t('请先登录'));
                return;
            }
            let data = {
                urlId: item.speActBigWheelVO.thematicActivitiesId,
                expand: {
                    actFolder: item.speActBigWheelVO.thematicActivitiesFolder,
                }
            }
            const obj = {
                activityId: data.urlId,
                token: this.$common.getToken(),
                clientCode: window.clientCode,
                clientItem: window.childCode,
                username: this.$common.getUser().username,
                language: this.$i18n.locale,
                theme: window.theme,
                host: this.$config.baseUrl,
            };
            const str = window.btoa(JSON.stringify(obj));
            const url = window.location.origin + '/func/' + data.expand.actFolder + "/pc/index.html?s=" + str;
            window.open(url);
        },
    }
};
</script>
<style lang="less" scoped>
.activityBanner {
    position:fixed;
    right:20px;
    bottom:20px;
    width:194px;
    height:200px;
    cursor:pointer;
    .container {
        position: relative;
        .swiper-pagination {
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);

            /deep/ .swiper-pagination-bullet {
                width: 15px;
                height: 15px;
                border-radius: 10px;
                background: #583503;
                opacity: 1;
                margin-right: 5px;
            }

            /deep/ .swiper-pagination-bullet-active {
                width: 15px;
                background: #ffff65;
            }

        }

        /deep/ .swiper-slide img {
            width:194px;
            height:200px;
            float: left;
            overflow: hidden;
        }

        /deep/ .swiper-slide-active .img {
            animation: btmToTop 1.5s;
        }
    }
}

@keyframes btmToTop {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
.close-btn{
  position: absolute;
    width: 23px;
    height: 34px;
    left: 0;
    top: -20px;
    cursor: pointer;
    z-index: 900;
    background: url('~@/assets/image/close.png') no-repeat center center;
    background-size: contain;
    
}
</style>